import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { ArrowBack } from '@mui/icons-material';

import { Tooltip } from '../../../_shared/tooltip/Tooltip';
import title from '../../../_assets/dbd-title.png';
import thumbnail from '../../../_assets/thumbnail/dbd.webp';
import { FaqDbd } from './faq-dbd/FaqDbd';
import { useConfig } from '../../../ConfigContext';
import { GameConfig } from '../../../Config.model';
import { Breadcrumb, BreadcrumbPath } from '../../../_shared/breadcrumb/Breadcrumb';
import { ProviderMerge } from '../../providers/provider/ProviderMerge';
import { Promotions } from '../../promotion/Promotions';
import { get } from '../../../utils/Request';
import { MergedAccount, MergeOperation } from '../../../authentication/Authentication.model';
import { useSnackbar } from '../../../snackbar/SnackbarContext';
import { RequestError } from '../../../Error.model';

export function DbdGame(): JSX.Element {
  const { t } = useTranslation(['dbd', 'translation']);
  const history = useHistory();
  const config = useConfig();
  const snackbar = useSnackbar();
  const [dbdConfig, setDbdConfig] = useState<GameConfig>(null);
  const [mergedAccounts, setMergedAccounts] = useState<MergedAccount[]>([]);
  const breadcrumb: BreadcrumbPath[] = [
    {
      key: 'button.my-account',
      path: '/account/my-account',
    },
    {
      key: 'Dead by Daylight',
      path: '',
    },
  ];
  const back = (): void => {
    history.push('/');
  };

  const getMergedAccounts = async (): Promise<void> => {
    try {
      setMergedAccounts(await get<MergedAccount[]>(
        `${config.clientConfig.host}/players/me/mergedAccounts/dbd`,
      ));
    } catch (e) {
      const err = e as RequestError;
      snackbar.addErrorMessage(err.code);
    }
  };

  useEffect(() => {
    const co = config.serverConfig.gamesConfig?.find(((gameConfig) => gameConfig.id === 'dbd'));

    if (!co) {
      history.push('/');
    } else {
      setDbdConfig(co);
      getMergedAccounts();
    }
  }, []);

  return (
    <div className='game-container our-game-container'>
      <img className='game-thumbnail' src={thumbnail} alt='DBD Thumbnail' />
      <div className='banner'>
        <button type='button' className='btn btn-secondary back-btn' onClick={back}>
          <ArrowBack className='icon' />
          {t('translation:button.back')}
        </button>
        <Breadcrumb paths={breadcrumb} />
        <img className='title' src={title} alt='title dbd' height={120} />

        <div className='subtitle'>
          <h3 className='cross-progression-title'>
            {t('translation:account.my-account.crossProgression')}
          </h3>
          <Tooltip id='tooltip.merge' message='tooltip.merge' />
        </div>

        <div className='providers-container'>
          {dbdConfig?.providers.map((provider) => (
            <ProviderMerge
              key={provider.name}
              gameId={dbdConfig.id}
              providerName={provider.name}
              disableMerge={provider.killswitch.includes(MergeOperation.MERGE)}
              disableUnmerge={provider.killswitch.includes(MergeOperation.UNMERGE)}
              initialMergedAccount={mergedAccounts?.find((account) => account.provider === provider.name)}
            />
          ))}
        </div>
        <Promotions />
      </div>

      <section className='faq' id='faq'>
        <FaqDbd />
      </section>
    </div>
  );
}
